import { IEmailAddOrEdit } from "../../../models/response/email/IEmailAddOrEdit";
import { IEmailUser } from "../../../models/response/email/IEmailUser";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from '../IGenericActionType';

export const eEmailFormDefine = {
    CHANGE_STEP_ID: 0,
    CHANGE_ID: 0,

    LOAD_EMAIL_START: 0,
    LOAD_EMAIL_SUCCESS: {} as IEmailAddOrEdit,
    LOAD_EMAIL_ERROR: "",

    LOAD_EMAIL_USER_START: 0,
    LOAD_EMAIL_USER_SUCCESS: [] as IEmailUser[],
    LOAD_EMAIL_USER_ERROR: "",

    SAVE_EMAIL_START: {} as IEmailAddOrEdit,
    SAVE_EMAIL_SUCCESS: 0,
    SAVE_EMAIL_ERROR: "",

    SAVE_EMAIL_USER_START: [] as IEmailUser[],
    SAVE_EMAIL_USER_SUCCESS: [] as IEmailUser[],
    SAVE_EMAIL_USER_ERROR: "",

    SEND_START: 0,
    SEND_SUCCESS: 0,
    SEND_ERROR: "",

}
export const eEmailFormActionTypeIds = generateActionTypeIds(eEmailFormDefine, "EMAIL_FORM")
export type IEmailFormActionTypes = IGenericActionType<typeof eEmailFormDefine, "EMAIL_FORM">